/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon'; // Outline

const XCircleOutline = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "m15 9-6 6m6 0L9 9m12 3a9 9 0 1 1-18.001-.001A9 9 0 0 1 21 12z"
})); // Fill


const XCircleFill = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12 2.25c-1.93 0-3.81.57-5.42 1.64-1.6 1.08-2.85 2.6-3.59 4.38s-.93 3.74-.55 5.63c.37 1.89 1.3 3.63 2.67 4.99 1.36 1.37 3.1 2.3 4.99 2.67 1.89.38 3.85.19 5.63-.55s3.31-1.99 4.38-3.59a9.75 9.75 0 0 0-1.22-12.31A9.793 9.793 0 0 0 12 2.25zm3.53 12.22c.15.14.22.33.22.53s-.07.39-.22.54c-.14.13-.33.21-.53.21s-.39-.08-.53-.21L12 13.06l-2.47 2.48c-.14.13-.33.21-.53.21s-.39-.08-.53-.21c-.15-.15-.22-.34-.22-.54s.07-.39.22-.53L10.94 12 8.47 9.54a.785.785 0 0 1-.18-.52c.01-.19.09-.37.23-.5.13-.14.31-.22.5-.23.18 0 .37.06.51.18L12 10.94l2.47-2.47c.14-.12.33-.18.51-.18.19.01.37.09.5.23.14.13.22.31.23.5.01.18-.06.37-.18.52L13.06 12l2.47 2.47z"
})); // DuoTone


const XCircleDuotone = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M12 21a9 9 0 1 0-.001-18.001A9 9 0 0 0 12 21z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeWidth: "var(--i-s-width)",
  d: "m15 9-6 6m6 0L9 9m12 3a9 9 0 1 1-18.001-.001A9 9 0 0 1 21 12z"
}));
/**
  Icon XCircleIcon in math group
*/


export const XCircleIcon = createIcon('XCircleIcon', 'x-circle', 'math', XCircleOutline, XCircleFill, XCircleDuotone, "0 0 24 24");